// extracted by mini-css-extract-plugin
export default {"name_description_container":"styles_name_description_container__2kTO7","input_label_name":"styles_input_label_name__2twbJ","input_column":"styles_input_column__1rY3q"};